// Client-side food-cost calculation for live preview on recipe edit page.
// Must match server logic in compute_recipe_cost.

const WEIGHT = { kg: 1, g: 0.001 };
const VOLUME = { l: 1, ml: 0.001 };

export function convertToBase(quantity, unit, baseUnit) {
    const q = Number(quantity);
    if (!Number.isFinite(q)) return null;
    if (unit === baseUnit) return q;
    if (unit in WEIGHT && baseUnit in WEIGHT) return (q * WEIGHT[unit]) / WEIGHT[baseUnit];
    if (unit in VOLUME && baseUnit in VOLUME) return (q * VOLUME[unit]) / VOLUME[baseUnit];
    if (unit === "pz" && baseUnit === "pz") return q;
    return null;
}

export function computeRecipeCost(recipe, ingredientsById) {
    let total = 0;
    let missing = 0;
    for (const ri of recipe.ingredients || []) {
        const ing = ingredientsById[ri.ingredient_id];
        if (!ing) {
            missing += 1;
            continue;
        }
        const qtyBase = convertToBase(ri.quantity, ri.unit, ing.unit);
        if (qtyBase === null || !Number.isFinite(qtyBase)) {
            missing += 1;
            continue;
        }
        const waste = Math.max(0, Math.min(Number(ing.waste_pct || 0), 99));
        const effective = waste < 100 ? qtyBase / (1 - waste / 100) : qtyBase;
        total += effective * Number(ing.cost_per_unit || 0);
    }
    const portions = Math.max(1, Number(recipe.portions) || 1);
    const costPerPortion = total / portions;
    const sp = Number(recipe.selling_price) || 0;
    const foodCostPct = sp > 0 ? (costPerPortion / sp) * 100 : 0;
    const margin = sp > 0 ? sp - costPerPortion : 0;
    const suggested = costPerPortion > 0 ? costPerPortion / 0.3 : 0;
    return {
        total_cost: total,
        cost_per_portion: costPerPortion,
        food_cost_pct: foodCostPct,
        margin,
        suggested_selling_price: suggested,
        missing_ingredients: missing,
    };
}

// Used for the purchase preview box
export function computePurchasePreview({ quantity, unit, total_price, ingredient }) {
    if (!ingredient) return null;
    const qtyBase = convertToBase(quantity, unit, ingredient.unit);
    if (qtyBase === null || !Number.isFinite(qtyBase) || qtyBase <= 0) return null;
    const tp = Number(total_price);
    if (!Number.isFinite(tp) || tp < 0) return null;
    const newCost = tp / qtyBase;
    return { quantity_base: qtyBase, new_cost: newCost, base_unit: ingredient.unit };
}
